const showValidationTooltip = (element, config) => {
    // to show tooltip just pass tooltip text and css class name
    if (!(config && config.toolTipText)) {
        return;
    }
    if (config.isPreChatText) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = `<div id='err_msg_id' class="apexchat_error_msg" title="${config.toolTipText}" tabindex="0">${config.toolTipText}</div>`
        element.parentElement.parentElement.querySelector('#err_msg_id')?.remove()

        element.closest('.apexchat_rd_prechat_input').classList.add(config.toolTipCss);
        element.parentElement.parentElement.append(wrapper)

    } else {
        element.querySelector(`span.${config.toolTipCss}_text`)?.remove();
        element.classList.add(config.toolTipCss);
        var wrapper = document.createElement('div');
        wrapper.innerHTML = `<span class="${config.toolTipCss}_text" title="${config.toolTipText}" tabindex="0">${config.toolTipText}</span>`

        element.append(wrapper);
    }
    return element
}
export default showValidationTooltip;